<app-header></app-header>
<app-sidenav></app-sidenav>
<app-online-help></app-online-help>
<app-alert></app-alert>
<div class="overlay" (click)="toggle()" *ngIf="isSidenavOpened || spinnerActive || isOnlineHelpSidenavOpened">
    <div class="spinner-border text-light" role="status" *ngIf="spinnerActive"></div>
</div>
<div class="container content-area" [ngClass]="isSidenavOpened || isOnlineHelpSidenavOpened ? 'sidenav-opened' : ''">
    <router-outlet></router-outlet>
    <mat-icon aria-hidden="false" aria-label="online-help-icon" class="online-help-icon" fontIcon="support"
        matTooltip="Guida in linea" (click)="toggleOnlineHelpSidenav()"></mat-icon>
</div>